
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["external",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 194.818 194.818"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M185.818 2.161h-57.04c-4.971 0-9 4.029-9 9s4.029 9 9 9h35.312l-86.3 86.3a9 9 0 006.364 15.364 8.975 8.975 0 006.364-2.636l86.3-86.3v35.313c0 4.971 4.029 9 9 9s9-4.029 9-9v-57.04a9 9 0 00-9-9.001z"}}),_c('path',{attrs:{"d":"M149 77.201a9 9 0 00-9 9v88.456H18v-122h93.778c4.971 0 9-4.029 9-9s-4.029-9-9-9H9a9 9 0 00-9 9v140a9 9 0 009 9h140a9 9 0 009-9V86.201a9 9 0 00-9-9z"}})])
          )
        }
      }
    